import { useAuth } from '@adflow/frontend/util-auth';
import { canUserSaveColumnTemplateForAll } from '@adflow/shared/util-column-templates';

export function useCanSaveColumnTemplateForAll() {
	const { user } = useAuth();

	return canUserSaveColumnTemplateForAll(user);
}
